<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th>投稿主題</th>
          <th>內容</th>
          <th>投稿者</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tr in contributionList" :key="tr.id">
          <td class="title">
            <router-link
              class="web_pic_item"
              :to="`/submit/${tr.pageId}?countryId=${countryId}`"
              :title="tr.pageTitle"
            >
              <p class="text_content" :style="{ fontSize: fontSize.p + 'em' }">
                {{ tr.pageTitle }}
              </p>
            </router-link>
          </td>
          <td class="content">
            <div class="ellipsis">
              <p
                :style="{ fontSize: fontSize.p + 'em' }"
                v-html="tr.pageContent"
              ></p>
            </div>
          </td>
          <td class="name">
            <p :style="{ fontSize: fontSize.p + 'em' }">{{ tr.posterName }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "ContributionTable",
  props: {
    contributionList: {
      type: Array,
      required: true,
    },
    countryId: {
      type: String,
      required: true,
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.table {
  // 1.電腦版
  table {
    width: 100%;
    thead {
      background-color: $main_color;
      color: #fff;
      tr {
        th {
          padding: 16px;
        }
      }
    }
    tbody {
      background-color: $bgc_gray;
      tr {
        border-bottom: #fff 3px solid;
        td {
          padding: 16px;
        }
        .title {
          width: 30%;
          text-align: initial;
        }
        .content {
          width: 50%;
          text-align: initial;
        }
        .ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
        .name {
          width: 20%;
        }
        .name > p:nth-child(2) {
          color: #818181;
        }
      }
    }
  }
}
</style>
